import '../../assets/components/Icon/icon.css';const t = "_iconWrapper_tj2nt_1", n = "_iconContainer_tj2nt_6", e = "_textIcon_tj2nt_15", o = "_labelText_tj2nt_20", c = {
  iconWrapper: t,
  iconContainer: n,
  textIcon: e,
  labelText: o
};
export {
  c as default,
  n as iconContainer,
  t as iconWrapper,
  o as labelText,
  e as textIcon
};
